<app-header [text]='!!category ? category.text : "default"'></app-header>

<div id="content">
<div id="readspeaker_button1" class="rs_skip rsbtn rs_preserve" *ngIf="env.readspeaker.enabled">
  <a rel="nofollow" class="rsbtn_play" accesskey="L" i18n-title="@@readSpeakerDescription" title="Listen to this page using ReadSpeaker webReader" [href]="getReadSpeakerURL('readspeaker_content')">
      <span class="rsbtn_left rsimg rspart"><span class="rsbtn_text"><span i18n="@@readSpeakerListen">Listen</span></span></span>
      <span class="rsbtn_right rsimg rsplay rspart"></span>
  </a>
</div>

<div id="readspeaker_content">
  <div class="previousScenario text" *ngIf="previousScenarioText !== ''">
    {{ 'That\'s the end of the ' + previousScenarioText + ' scenario' }}
  </div>

  <!--<div id="content">-->
    <div class="row">
      <div class="col-12 col-xl-6">
        <div id="media-container">
          <app-media [resource]=assistantAsset [texts]=imageTexts></app-media>
        </div>
      </div>
      <div class="col-12 col-xl-6">
        <div class="text">
          <div *ngIf="this.scenarioIndex <= 0; else elseBlock">
            <div class="heading" i18n="">The tasks will check your Skills in:</div>
            <div class="features container-fluid">
              <div class="row">
                <div class="col-4 col-xl-4">
                  <div class="row icon d-flex justify-content-center">
                    <div class="box">
                      <fa-icon [icon]="faLaptop"></fa-icon>
                    </div>
                  </div>
                  <div class="row text d-flex justify-content-center" i18n="@@skill-computers-simple">
                    Computers
                  </div>
                </div>
                  <div class="col-4 col-xl-4">
                    <div class="row icon d-flex justify-content-center">
                      <div class="box">
                        <fa-icon [icon]="faCalculator"></fa-icon>
                      </div>
                    </div>
                    <div class="row text d-flex justify-content-center"  i18n="@@skill-maths-simple">
                      Maths
                    </div>
                  </div>
                  <div class="col-4 col-xl-4">
                    <div class="row icon d-flex justify-content-center">
                      <div class="box">
                        <fa-icon [icon]="faBookOpen"></fa-icon>
                      </div>
                    </div>
                    <div class="row text d-flex justify-content-center" i18n="@@skill-reading-and-writing-simple">
                      Reading and Writing
                    </div>
                  </div>
                </div>
              </div>
              <div class="text spaced" i18n="">Each task will take about <b>2 minutes</b>.</div>
              <div class="text spaced" i18n="">Watch each video, think about the task, and answer some questions.</div>
              <div class="text spaced" i18n="">Click <b>Let's Go</b> to begin!</div>
          </div>
          <ng-template #elseBlock>
            <img class="ballons" src="../../../../assets/balloons/balloons-bbb.svg" alt="">
            <br>
            <div class="text" i18n="">Click <b>Continue</b> to go to <b>Task {{ scenarioIndex + 1 }}</b></div>
          </ng-template>
      </div>
    </div>
  </div>
</div>
</div>
<div class="footer">
  <div class="progress" *ngIf="this.scenarioIndex > 0">
    <div
      class="progress-bar"
      role="progressbar"
      [style.width]="progress+'%'" 
      [attr.aria-valuenow]="progress"
      aria-valuemin="0"
      aria-valuemax="100"
    ><span *ngIf="progress==15 || progress>15" i18n="@@progressBarLabel">{{progress}}% Complete!</span></div>
    <span class="progress-bar-label" *ngIf="progress < 15" i18n="@@progressBarLabel">{{progress}}% Complete!</span>
  </div>
  <app-navigate-button
  backText="{{ btnBack }}"
  forwardText="{{ btnForward }}"
  (backEvent)="previousScenario()"
  (forwardEvent)="startScenario()"
  ></app-navigate-button>
</div>